import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-293e327b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  class: "image",
  href: "#"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "overlay" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "descriptions" }
const _hoisted_7 = { href: "#" }
const _hoisted_8 = { class: "price-deadline" }
const _hoisted_9 = { class: "currency" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "days left", -1))
const _hoisted_12 = { class: "creator" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Creation of ")
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("img", {
        class: "thumbnail",
        src: _ctx.img,
        alt: _ctx.altImg
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          class: "icon",
          src: _ctx.viewImg,
          alt: _ctx.viewAlt
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", _hoisted_7, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _createTextVNode(_toDisplayString(_ctx.value) + " ", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.currency), 1)
      ]),
      _createElementVNode("span", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.time) + " ", 1),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("img", {
        src: _ctx.avatar,
        alt: _ctx.avatarAlt
      }, null, 8, _hoisted_13),
      _createElementVNode("span", null, [
        _hoisted_14,
        _createElementVNode("a", {
          href: _ctx.creatorLink,
          target: "_blank"
        }, _toDisplayString(_ctx.creator), 9, _hoisted_15)
      ])
    ])
  ]))
}